import Vue from 'vue'
import Vuex from 'vuex'

import AppEnv from './modules/app_env'
import Loading from './modules/loading'
import FontSize from './modules/font_size'
import User from './modules/user'
import Building from './modules/building'
import Room from './modules/room'
import RoomSaveError from './modules/room_save_error'
import Master from './modules/master'
import PropertyTemplate from './modules/property_template'
import WarrantyCompany from './modules/warranty_company' // 保証会社
import Ea from './modules/ea'
import Ksk from './modules/ksk'
import ModalBuildingEditorParking from './modules/modal_building_editor_parking'
import ModalBuildingEditorTransaction from './modules/modal_building_editor_transaction'
import ModalBuildingEditorKsk from './modules/modal_building_editor_ksk'
import ModalContractInfoForm from './modules/modal_contract_info_form'
import ModalCatch from './modules/modal_catch'
import ModalAiCatch from './modules/modal_ai_catch'
import ModalCatchTemplate from './modules/modal_catch_template'
import ModalNoteTemplate from './modules/modal_note_template'
import ModalImagePreview from './modules/modal_image_preview'
import ModalImageEditor from './modules/modal_image_editor'
import ModalSuumoscore from './modules/modal_suumoscore'
import ModalSaveSuccess from './modules/modal_save_success'
import ModalError from './modules/modal_error'
import ModalConvertError from './modules/modal_convert_error'
import ImageSort from './modules/image_sort'
import SuumoScore from './modules/suumo_score'
import PortalSiteLink from './modules/portal_site_link'
import PropertyInfo from './modules/property_info'
import AIImageCategory from './modules/ai_image_category'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    AppEnv,
    Loading,
    FontSize,
    User,
    Building,
    Room,
    RoomSaveError,
    Master,
    PropertyTemplate,
    WarrantyCompany,
    Ea,
    Ksk,
    ModalBuildingEditorParking,
    ModalBuildingEditorTransaction,
    ModalBuildingEditorKsk,
    ModalContractInfoForm,
    ModalCatch,
    ModalAiCatch,
    ModalCatchTemplate,
    ModalNoteTemplate,
    ModalImagePreview,
    ModalImageEditor,
    ModalSuumoscore,
    ModalSaveSuccess,
    ModalError,
    ModalConvertError,
    ImageSort,
    SuumoScore,
    PortalSiteLink,
    PropertyInfo,
    AIImageCategory,
  },
})
